import React from 'react';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { numberOfDays } from 'utils/formatter/number-of-days';
import { AppState } from 'services/types';
import ListItem from 'components/ListItem';
import { makeSelectWithholdingPeriodDays } from './selectors';

interface ConnectedProps {
    withholdingPeriod: number;
}

export interface OwnProps {
    productId: ProductId;
}

export type Props = ConnectedProps & OwnProps;

export class WithholdingPeriodListItemComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { withholdingPeriod } = this.props;

        return (
            <ListItem
                value={numberOfDays(withholdingPeriod)}
                description="Withholding period"
            />
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    withholdingPeriod: makeSelectWithholdingPeriodDays()
});

export default connect(mapStateToProps)(WithholdingPeriodListItemComponent);
